/* eslint-disable */
import { WarningBox } from '@linearb/linui-common/base';
import { Box } from '@material-ui/core';
import {
  RATE_LIMIT_ISSUE_THRESHOLD,
  useSensorAuthRateLimitCounts
} from 'common/hooks/useSensorAuthRateLimitCounts';
import { useSelector } from 'react-redux';
import { getSensorAuthorizations } from 'state/selectors/sensors-authorizations';
import { SensorAuthorization } from 'types/sensorAuthorization';
import { isAdmin, isSuperUser } from 'common/services/accounts.service';
import { myAccountSelector } from 'state/selectors/account';

export function SensorRateLimitWarning() {
  const sensorAuthorizations: SensorAuthorization[] = useSelector(
    getSensorAuthorizations
  );
  const account = useSelector(myAccountSelector);
  const rateLimitIssueCounts =
    useSensorAuthRateLimitCounts(sensorAuthorizations);

  const isRateLimitRateExceeded = rateLimitIssueCounts.some(
    value => value > RATE_LIMIT_ISSUE_THRESHOLD
  );

  const shouldShowRateLimitMsg =
    isRateLimitRateExceeded && (isAdmin(account) || isSuperUser(account));

  if (!shouldShowRateLimitMsg) {
    return null;
  }

  return (
    <Box margin={1} marginTop={2} data-testid='rate-limit-warning'>
      <WarningBox>
        It appears that one of your Git integrations has encountered rate limit
        errors, which may affect data consistency and accuracy. Please reach out
        to our support team for assistance.
      </WarningBox>
    </Box>
  );
}
